import { render, staticRenderFns } from "./AddressSummary.vue?vue&type=template&id=6c6db8d2&"
import script from "./AddressSummary.vue?vue&type=script&lang=js&"
export * from "./AddressSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports